import { PotentialBookingSummary } from '@sales-app/types/SupervisorDashboard'

export const PotentialBookingSummaryColumns = [
  {
    Header: 'Agent',
    accessor: 'agentName',
    Width: 75,
  },
  {
    Header: 'Status',
    accessor: 'agentCurrentStatus',
    width: 40,
  },
  {
    Header: 'New',
    accessor: 'new',
    width: 60,
  },
  {
    Header: 'Application started',
    accessor: 'applicationStarted',
    width: 60,
  },
  {
    Header: 'Automated first contact',
    accessor: 'automatedFirstContact',
    width: 60,
  },
  {
    Header: 'Needs action',
    accessor: 'needsAction',
    width: 60,
  },
  {
    Header: 'Follow up',
    accessor: 'followUp',
    width: 60,
  },
]

export const transformedPotentialBookingSummary = (
  potentialBookings: PotentialBookingSummary[],
): PotentialBookingSummaryRow[] => {
  return potentialBookings.map((p) => {
    const agent = p.agent
    const potentialBookingsByStatus = p.potentialBookingsByStatus

    return {
      agentId: agent.id,
      agentName: agent.name,
      agentCurrentStatus: agent.currentStatus ? agent.currentStatus : 'Offline',
      new: potentialBookingsByStatus.new ? potentialBookingsByStatus.new : 0,
      applicationStarted: potentialBookingsByStatus.applicationStarted
        ? potentialBookingsByStatus.applicationStarted
        : 0,
      automatedFirstContact: potentialBookingsByStatus.automatedFirstContact
        ? potentialBookingsByStatus.automatedFirstContact
        : 0,
      needsAction: potentialBookingsByStatus.needsAction ? potentialBookingsByStatus.needsAction : 0,
      followUp: potentialBookingsByStatus.followUp ? potentialBookingsByStatus.followUp : 0,
    }
  })
}

interface PotentialBookingSummaryRow {
  agentCurrentStatus: string | null
  agentId: number | null
  agentName: string | null
  applicationStarted: number | null
  automatedFirstContact: number | null
  followUp: number | null
  needsAction: number | null
  new: number | null
}
